module.exports = __webpack_public_path__ + "static/img/arbovirus.1e35b9b.svg";